function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#F8F9FB"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1351.823 306.645l-1.2 1.2-2.2-2.2 1.2-1.2c.32-.32.82-.32 1.14 0l1.08 1.08c.3.3.3.82-.02 1.12zm-9.8 9.82l-2.22-2.2 7.76-7.76 2.22 2.22-7.76 7.74zm-3.52 1.3l.74-2.38 1.66 1.66-2.4.72zm13.1-14.18c-.78-.78-2.04-.78-2.82 0l-10.26 10.24c-.04.04-.06.06-.08.1 0 0 0 .02-.02.02-.02.04-.04.06-.04.1v.02l-1.36 4.44c-.06.22 0 .44.14.6.12.12.26.18.42.18.06 0 .12 0 .18-.02l4.42-1.36h.02c.04-.02.08-.02.1-.04 0 0 .02 0 .02-.02.04-.02.08-.04.1-.08l10.24-10.24c.78-.78.78-2.04 0-2.82l-1.06-1.12z",
  transform: "translate(-1337 -303)"
})));

function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.57d5c885.svg";
export { ForwardRef as ReactComponent };